import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetogoataxiservice() {



const cardData =
{
  keyword: 'Pune to Goa Taxi Service',

  heading: 'Lotus Cab: Pune to Goa Taxi Service ',

headingDescription:
  "Lotus Cabs offers reliable and affordable Pune to Goa Taxi Service for family vacations, corporate trips, business travel, airport transfers, student travel, sightseeing tours, and one-way or round-trip journeys. Our premium fleet includes Sedan, SUV, Innova Crysta, Ertiga, Kia Carens, Tempo Traveller, Luxury Urbania, and Mini Bus, driven by professional and experienced chauffeurs to provide a safe and comfortable travel experience. With 24x7 booking support, transparent pricing, doorstep pickup from any location in Pune, well-maintained vehicles, and smooth long-distance highway travel, Lotus Cabs ensures a convenient, punctual, and hassle-free taxi service from Pune to Goa.",


  top: 'Top Places to Visit in Goa before Traveling to Pune with Lotus Cab',

topPlaces: [

    {
        title: "Church of Our Lady of the Immaculate Conception",
        description:
            "Located in Panaji, the Church of Our Lady of the Immaculate Conception is famous for its iconic white façade, elegant stairways, and centuries-old history. It is one of Goa's most photographed landmarks and offers beautiful views of the city."
    },
  
      {
        title: "Vagator Beach",
        description:
            "Vagator Beach is a scenic coastal destination known for its dramatic red cliffs, soft golden sand, and breathtaking sunsets over the Arabian Sea. The beach offers a peaceful atmosphere, trendy cafés, and stunning viewpoints, making it a favorite among photographers and couples."
    },
     {
        title: "Butterfly Beach",
        description:
            "Butterfly Beach is a secluded paradise surrounded by lush forests and crystal-clear waters. Accessible mainly by boat or trekking, the beach is ideal for travelers seeking tranquility, dolphin sightings, and breathtaking natural beauty."
    },
       {
        title: "Se Cathedral",
        description:
            "Se Cathedral is one of the largest churches in Asia and a remarkable example of Portuguese-Gothic architecture. Dedicated to Saint Catherine, the cathedral is admired for its grand interiors, historic significance, and the famous Golden Bell."
    },
    {
        title: "Colva Beach",
        description:
            "Colva Beach is one of South Goa's most beautiful beaches, stretching for several kilometers with soft white sand and swaying coconut palms. Visitors enjoy swimming, beach walks, water sports, seafood restaurants, and a relaxing coastal ambiance."
    },
    {
        title: "Arambol Beach",
        description:
            "Arambol Beach is popular for its bohemian vibe, live music, yoga retreats, and vibrant beachside cafés. The beach attracts backpackers and international travelers looking for a laid-back atmosphere and unforgettable sunset views."
    },
    {
        title: "Divar Island",
        description:
            "Divar Island is a peaceful river island that showcases Goa's traditional village life, Portuguese-era churches, scenic landscapes, and lush paddy fields. Visitors enjoy ferry rides, cycling, and exploring the island's rich cultural heritage."
    },
    {
        title: "Naval Aviation Museum",
        description:
            "The Naval Aviation Museum in Vasco da Gama displays vintage aircraft, helicopters, engines, and naval artifacts that highlight the history of the Indian Navy's aviation wing. It is an educational attraction for families and aviation enthusiasts."
    },
    {
        title: "Mollem National Park",
        description:
            "Mollem National Park is a biodiversity hotspot located in the Western Ghats, home to diverse wildlife, dense forests, waterfalls, and numerous trekking trails. Nature lovers visit the park to experience Goa's rich flora and fauna."
    },
    {
        title: "Fontainhas",
        description:
            "Fontainhas is Goa's charming Latin Quarter, famous for its colorful Portuguese-style houses, narrow winding streets, art galleries, cafés, and vibrant cultural heritage. Walking through this picturesque neighborhood offers a glimpse into Goa's colonial past."
    }
],





"services": [
  {
    "name": "Pune to Goa Taxi Service",
    "description": "Book Pune to Goa taxi service for comfortable and hassle-free intercity travel covering approximately 450 km via NH48. Choose from sedan, Ertiga, Innova Crysta, and SUV options for one-way and round-trip journeys. Professional drivers, clean AC vehicles, and transparent pricing ensure a safe and enjoyable ride. Ideal for family vacations, weekend getaways, corporate travel, and beach holidays with convenient doorstep pickup and drop services."
  },
  {
    "name": "Pune to Goa Cab Service",
    "description": "Reliable Pune to Goa cab service offering comfortable long-distance transportation with experienced chauffeurs and well-maintained vehicles. Flexible travel packages are available for one-way, round-trip, and customized itineraries. Suitable for tourists, families, and business travelers seeking affordable and convenient travel with transparent pricing and on-time service."
  },
  {
    "name": "Pune to Goa Taxi",
    "description": "Book a Pune to Goa taxi for a smooth and relaxing journey to Goa's famous beaches and tourist destinations. AC vehicles with comfortable seating and ample luggage space make long-distance travel convenient. Available for solo travelers, couples, families, and groups with flexible pickup timings and professional drivers."
  },
  {
    "name": "Pune to Goa Cab",
    "description": "Comfortable Pune to Goa cab service designed for safe and convenient intercity travel. Select from economy sedans, spacious Ertiga cabs, premium Innova Crysta, and SUVs according to your travel requirements. Enjoy transparent fares, experienced drivers, and flexible booking options for leisure and business trips."
  },
  {
    "name": "Pune to Goa Outstation Taxi",
    "description": "Pune to Goa outstation taxi service provides reliable transportation for long-distance travel with clean and well-maintained vehicles. Perfect for holiday trips, family vacations, and corporate journeys, this service includes professional drivers, transparent pricing, and comfortable seating for a stress-free experience."
  },
  {
    "name": "Pune to Goa One Way Taxi",
    "description": "Affordable Pune to Goa one way taxi service allowing passengers to pay only for the single-side journey without return charges. Ideal for tourists, relocations, and extended stays in Goa. Multiple vehicle options and transparent pricing help make travel economical and convenient."
  },
  {
    "name": "Pune to Goa Round Trip Taxi",
    "description": "Flexible Pune to Goa round trip taxi packages are available for weekend vacations, business meetings, and family holidays. Travelers can choose customized return schedules and enjoy comfortable AC vehicles with experienced drivers for a safe and memorable journey."
  },
  {
    "name": "Pune to Goa Airport Taxi",
    "description": "Reliable Pune to Goa airport taxi service offering convenient pickups and drops for travelers arriving at or departing from Goa airports. The service includes luggage assistance, timely departures, and comfortable long-distance travel in professionally maintained vehicles."
  },
  {
    "name": "Pune to Goa Family Cab",
    "description": "Pune to Goa family cab service is perfect for group travel and family vacations with spacious vehicles and comfortable seating. Innova Crysta and Ertiga options provide extra luggage space and ensure a pleasant journey for children, adults, and senior citizens."
  },
  {
    "name": "Pune to Goa Innova Taxi",
    "description": "Premium Pune to Goa Innova taxi service offering spacious seating, superior comfort, and smooth highway performance. Ideal for family trips, corporate travel, and group vacations with extra luggage requirements and long-distance travel needs."
  },
  {
    "name": "Pune to Goa Ertiga Taxi",
    "description": "Affordable Pune to Goa Ertiga taxi service with comfortable seating for up to six passengers. Perfect for small groups and families seeking economical and comfortable travel with professional drivers and well-maintained AC vehicles."
  },
  {
    "name": "Pune to Goa Sedan Taxi",
    "description": "Pune to Goa sedan taxi service is ideal for solo travelers, couples, and small families looking for budget-friendly transportation. Comfortable seating, air conditioning, and professional drivers make the long-distance journey enjoyable and convenient."
  },
  {
    "name": "Pune to Goa Luxury Cab",
    "description": "Luxury cab service from Pune to Goa featuring premium vehicles with enhanced comfort and spacious interiors. Suitable for corporate executives, VIP guests, and travelers seeking a superior travel experience with professional chauffeurs and personalized service."
  },
  {
    "name": "Pune to Goa Taxi Booking",
    "description": "Easy Pune to Goa taxi booking service with instant confirmation, flexible scheduling, and multiple vehicle options. Customers can choose one-way, round-trip, or customized packages with transparent pricing and dependable customer support."
  },
  {
    "name": "Pune to Goa Cab Booking",
    "description": "Book your Pune to Goa cab in advance for a smooth and stress-free journey. Convenient online booking, transparent fares, and a wide fleet of vehicles make it easy to plan family vacations, corporate trips, and weekend getaways."
  },
  {
    "name": "Best Pune to Goa Taxi Service",
    "description": "Best Pune to Goa taxi service offering reliable drivers, clean vehicles, and excellent customer support. Enjoy comfortable long-distance travel with transparent pricing, on-time pickups, and flexible packages designed for families, tourists, and business travelers."
  },
  {
    "name": "Affordable Pune to Goa Taxi",
    "description": "Budget-friendly Pune to Goa taxi service providing comfortable and economical transportation without compromising safety or quality. Multiple vehicle choices and competitive pricing make it an ideal option for tourists, families, and regular travelers."
  }
],

"tableData": [
  ["Pune to Goa Taxi Service", "Pune to Goa Cab Service"],
  ["Pune to Goa Taxi", "Pune to Goa Cab"],
  ["Pune to Goa Outstation Taxi", "Pune to Goa One Way Taxi"],
  ["Pune to Goa Round Trip Taxi", "Pune to Goa Airport Taxi"],
  ["Pune to Goa Family Cab", "Pune to Goa Innova Taxi"],
  ["Pune to Goa Ertiga Taxi", "Pune to Goa Sedan Taxi"],
  ["Pune to Goa Luxury Cab", "Pune to Goa Taxi Booking"],
  ["Pune to Goa Cab Booking", "Best Pune to Goa Taxi Service"],
  ["Affordable Pune to Goa Taxi", ""]
],






"whychoose": [
  {
    "WhyChooseheading": "Reliable Intercity Taxi Service",
    "WhyChoosedescription": "Travel from Pune to Goa with dependable taxi services designed for comfort and convenience."
  },
  {
    "WhyChooseheading": "Affordable Pricing Options",
    "WhyChoosedescription": "Competitive fares with transparent billing and no hidden charges."
  },
  {
    "WhyChooseheading": "One Way & Round Trip Availability",
    "WhyChoosedescription": "Book taxis for one-way travel, return journeys, or customized trip plans."
  },
  {
    "WhyChooseheading": "Wide Range of Vehicles",
    "WhyChoosedescription": "Choose from Sedan, Ertiga, Innova Crysta, and spacious SUVs based on your travel needs."
  },
  {
    "WhyChooseheading": "Pickup from Any Location in Pune",
    "WhyChoosedescription": "Convenient pickup service from homes, offices, hotels, airports, and railway stations."
  },
  {
    "WhyChooseheading": "Comfortable AC Vehicles",
    "WhyChoosedescription": "Travel in clean, sanitized, and air-conditioned taxis for a pleasant journey."
  },
  {
    "WhyChooseheading": "Professional Chauffeurs",
    "WhyChoosedescription": "Experienced drivers ensure safe travel through highways and ghat roads."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Get round-the-clock assistance for bookings, fare inquiries, and travel information."
  }
]
};

const faqData = [
  {
    question: 'Does Lotus Cab provide Pune to Goa taxi service?',
    answer: 'Yes, Lotus Cab offers reliable Pune to Goa taxi services for one-way, round-trip, and customized travel requirements.'
  },
  {
    question: 'What is the distance between Pune and Goa by taxi?',
    answer: 'The distance between Pune and Goa is approximately 450 km, and the journey usually takes around 8 to 10 hours depending on traffic and route conditions.'
  },
  {
    question: 'How much does a Pune to Goa taxi service cost?',
    answer: 'Taxi fares vary based on the vehicle type, travel date, and trip requirements. Lotus Cab provides affordable pricing with complete transparency.'
  },
  {
    question: 'Can I book a one-way taxi from Pune to Goa?',
    answer: 'Yes, we offer economical one-way taxi services for travelers planning a direct trip to Goa.'
  },
  {
    question: 'Which vehicles are available for Pune to Goa travel?',
    answer: 'Our fleet includes Sedan cars, Ertiga, Innova Crysta, and SUVs suitable for solo travelers, families, and groups.'
  },
  {
    question: 'Do you provide airport pickup in Pune?',
    answer: 'Yes, Lotus Cab offers pickup services from Pune Airport, railway stations, hotels, and residential areas.'
  },
  {
    question: 'Are toll and state taxes included in the fare?',
    answer: 'Toll charges, parking fees, and state taxes are generally charged separately unless specifically mentioned in the booking package.'
  },
  {
    question: 'Is night travel available from Pune to Goa?',
    answer: 'Yes, our taxi service is available for both daytime and overnight departures according to your convenience.'
  },
  {
    question: 'Can I pre-book my Pune to Goa taxi?',
    answer: 'Absolutely. Advance booking is recommended to secure your preferred vehicle and travel schedule.'
  },
  {
    question: 'How can I book Pune to Goa Taxi Service with Lotus Cab?',
    answer: 'Simply share your pickup location, travel date, number of passengers, and preferred vehicle to receive an instant quotation and booking confirmation.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Vivek Shinde',
    feedback: 'Our friends planned a Goa road trip and Lotus Cab made the journey memorable. The taxi was comfortable, and the driver knew the route very well.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Mrs. Poonam Agarwal',
    feedback: 'I wanted a dependable taxi service for my family vacation to Goa. From pickup to drop-off, everything was managed professionally and the ride was extremely pleasant.',
    rating: 5,
  },
];









































































const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune Taxi Fare", link: "Pune-Taxi-Fare" },
  { place: "/images/keyword/2.jpg", text: "Pune Outstation Taxi Hire", link: "Pune-Outstation-Taxi-Hire" },
  { place: "/images/keyword/3.jpg", text: "Pimpri Chinchwad Online Cab", link: "Pimpri-Chinchwad-Online-Cab" },
  { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "Best-Cab-Service-in-Pune" },
  { place: "/images/keyword/5.jpg", text: "Pune to Mumbai One Way Cabs", link: "Pune-to-Mumbai-One-Way-Cabs" },
  { place: "/images/keyword/6.jpg", text: "Pune to Nasik Cabs", link: "Pune-to-Nasik-Cabs" },
  { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "Pune-to-Mahabaleshwar-Cabs" },
  { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cab Booking", link: "Pune-to-Lonavala-Cab-Booking" },
  { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cabs", link: "Pune-to-Shirdi-Cabs" },
  { place: "/images/keyword/10.jpg", text: "Pune to Lavasa City Cabs", link: "Pune-to-Lavasa-City-Cabs" },
  { place: "/images/keyword/11.jpg", text: "Pune Airport to Bhimashankar Cabs", link: "Pune-Airport-to-Bhimashankar-Cabs" },
  { place: "/images/keyword/12.jpg", text: "Pune to Indore Cabs", link: "Pune-to-Indore-Cabs" },
  { place: "/images/keyword/13.jpg", text: "Pune to Konkan Darshan Cabs", link: "Pune-to-Konkan-Darshan-Cabs" },
  { place: "/images/keyword/14.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
  { place: "/images/keyword/15.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
  { place: "/images/keyword/16.jpg", text: "Pune to Panchgani Cab Booking", link: "Pune-to-Panchgani-Cab-Booking" },
  { place: "/images/keyword/17.jpg", text: "Pune to Mumbai International Airport Taxi", link: "Pune-to-Mumbai-International-Airport-Taxi" },
  { place: "/images/keyword/18.jpg", text: "Ashtavinayak Darshan Cab Package", link: "Ashtavinayak-Darshan-Cab-Package" },
  { place: "/images/keyword/19.jpg", text: "Pune To Nagpur Cabs", link: "Pune-To-Nagpur-Cabs" },
  { place: "/images/keyword/20.jpg", text: "Cab Service in Kharadi", link: "Cab-Service-in-Kharadi" },
  { place: "/images/keyword/21.jpg", text: "Taxi Service in Hinjewadi Pune", link: "Taxi-Service-in-Hinjewadi-Pune" },
  { place: "/images/keyword/22.jpg", text: "Pune to Gujarat Cab Service", link: "Pune-to-Gujarat-Cab-Service" },
  { place: "/images/keyword/23.jpg", text: "Travel Agents in Pune", link: "Travel-Agents-in-Pune" },
  { place: "/images/keyword/24.jpg", text: "Pune to Thane Cab", link: "Pune-to-Thane-Cab" },
  { place: "/images/keyword/25.jpg", text: "Pune to Bangalore Taxi Service", link: "Pune-to-Bangalore-Taxi-Service" },

];








const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "Pune to Goa Taxi Service",
"image": "https://lotuscab.com/assets/images/pune-to-goa-taxi-service.jpg",
"description": "Book Pune to Goa Taxi Service with Lotus Cab for safe, comfortable, and reliable outstation travel. Enjoy one way, round trip, airport, and private taxi services with sedan, Innova, Ertiga, and SUV cabs driven by professional drivers available 24x7.",
"brand": {
"@type": "Brand",
"name": "Lotus Cab"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "7215"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Starting From ₹18/Km",
"availability": "https://schema.org/InStock",
"url": "https://lotuscab.com/pune-to-goa-taxi-service"
}
};






  return (
    <div>
      



<Helmet>
  <title>Pune to Goa Taxi Service | Outstation Cab Booking | +91 8767592195</title>

<meta
 name="description"
 content="Book Pune to Goa Taxi Service with Lotus Cab for affordable and comfortable travel. Get one way, round trip, airport, and outstation taxi services with premium sedan, Innova, Ertiga, and SUV cabs available 24x7."
/>

<meta
 name="keywords"
 content="Pune to Goa Taxi Service, Pune to Goa Cab Service, Pune to Goa Taxi, Pune to Goa Cab, Pune to Goa Outstation Taxi, Pune to Goa One Way Taxi, Pune to Goa Round Trip Taxi, Pune to Goa Airport Taxi"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>





 <section className="page-header">
      
      {/* Background Image */}
      <div
        className="page-header__bg"
        style={{
          backgroundImage:
            "url(../images/page-header-bg-1-1.jpg)",
        }}
      ></div>
      <div className="container">
        <div className="page-header__content">
        
          <h2 className="page-header__title"> {cardData.keyword}</h2>
        </div>
      </div>
    </section>


      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/101.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Lotus Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Lotus Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918767592195" className="pc-call">+91 8767592195</a>
                      <a href="tel:+919172145909" className="pc-call">+91 9172145909</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918767592195"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918767592195" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@lotuscab.com" className="pc-email">
                      booking@lotuscab.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Lotus Cab </strong><br />
                    Mauli Krupa building,
                    Sant Tukaram Nagar Gali No.1,
                    Navi sangvi MK chauk -411027
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetogoataxiservice;